// extracted by mini-css-extract-plugin
export default {"filterPanelTextArea":"src-components-Filter-components-collapsable-TextInput__filterPanelTextArea--J6ikP"};